module.exports = __webpack_public_path__ + "img/nut-pistachios-190x100.11f4ac98.jpg";